import { Popper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { useState } from 'react';

import { formatDateTime } from '../../util/helpers';
import { headerStyles } from '../Contracts/ContractsTable';

interface Task {
  source: string;
  subtaskCount: number;
  subtaskCompleted: number;
  success: number;
  failed: number;
  startDate?: string;
  endDate?: string;
  // errors is a map of error message -> occurrence count, not an array.
  errors: Record<string, number>;
}
interface TaskErrorRowProps {
  task: Task;
}

// Task data reaches this component after CustomSegmentsForm's normalizeForm
// camelCases every key from the Rails payload — so start_date/end_date and
// subtask_count/subtask_completed here are the camelCased forms, not the
// snake_case shapes shown in Ventura's raw JSON. ADOPS-2713 was the date cells
// being empty because the destructure was still reading snake_case keys.
function TaskErrorRow(props: TaskErrorRowProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handlePopoverOpen = (e: React.MouseEvent<HTMLElement>) => {
    // Anchor to the element the handler is bound to (the span), not e.target,
    // which can be a child text node and would mis-anchor the Popper.
    setAnchorEl(e.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const {
    task: { source, subtaskCount, subtaskCompleted, success, failed, startDate, endDate, errors },
  } = props;

  const headerStylesCss = headerStyles();

  return (
    <TableRow>
      <TableCell>{source}</TableCell>
      <TableCell>{subtaskCount}</TableCell>
      <TableCell>{subtaskCompleted}</TableCell>
      <TableCell>{success}</TableCell>
      <TableCell>{failed}</TableCell>
      <TableCell>{formatDateTime(startDate)}</TableCell>
      <TableCell>{formatDateTime(endDate)}</TableCell>
      <TableCell>
        <span onMouseEnter={handlePopoverOpen} onMouseLeave={handlePopoverClose}>
          View {Object.values(errors).reduce((previousValue, currentValue) => previousValue + Number(currentValue), 0)}{' '}
          Errors
        </span>
        <Popper anchorEl={anchorEl} open={Boolean(anchorEl)} placement="top-start">
          <TableContainer className={headerStylesCss.root}>
            <Table style={{ width: '100%' }}>
              <TableHead>
                <TableRow>
                  <TableCell>Occurrence Count</TableCell>
                  <TableCell>Error Message</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.keys(errors).map((error, index) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <TableRow key={`${index}-${error}`}>
                    <TableCell>{errors[error]}</TableCell>
                    <TableCell>{error}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Popper>
      </TableCell>
    </TableRow>
  );
}

export default TaskErrorRow;
